module.exports = __webpack_public_path__ + "img/google_playstore_black.4eff248a.png";